import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=2856eaac&scoped=true"
import script from "./transferRecord.vue?vue&type=script&lang=js"
export * from "./transferRecord.vue?vue&type=script&lang=js"
import style0 from "./transferRecord.vue?vue&type=style&index=0&id=2856eaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2856eaac",
  null
  
)

export default component.exports